<template>
  <path
    d="M17 1.01024L7 1.00024C5.9 1.00024 5 1.90024 5 3.00024V21.0002C5 22.1002 5.9 23.0002 7 23.0002H17C18.1 23.0002 19 22.1002 19 21.0002V3.00024C19 1.90024 18.1 1.01024 17 1.01024ZM17 19.0002H7V5.00024H17V19.0002ZM14.79 13.0002H13V9.00024C13 8.45024 12.55 8.00024 12 8.00024C11.45 8.00024 11 8.45024 11 9.00024V13.0002H9.21C8.76 13.0002 8.54 13.5402 8.86 13.8502L11.65 16.6402C11.85 16.8402 12.16 16.8402 12.36 16.6402L15.15 13.8502C15.46 13.5402 15.24 13.0002 14.79 13.0002Z"
  />
</template>
